module.exports = __webpack_public_path__ + "static/media/bathroom-tile-clean.e7ecf566.png";